import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { BASE_PATH } from './variables';

export function provideApi(basePath: string): EnvironmentProviders {
  return makeEnvironmentProviders([{ provide: BASE_PATH, useValue: basePath }]);
}
